const serverlessConfig = {
  endpoints: {
    vehicleListURL: 'https://h5gywnncj1.execute-api.eu-west-1.amazonaws.com/dev/vehiclelist',
    vehicleRecordsURL: 'https://h5gywnncj1.execute-api.eu-west-1.amazonaws.com/dev/vehiclerecord'
  }
};

export default serverlessConfig;
